import { render, staticRenderFns } from "./modelObmen.vue?vue&type=template&id=2aae6de5&scoped=true&"
import script from "./modelObmen.vue?vue&type=script&lang=js&"
export * from "./modelObmen.vue?vue&type=script&lang=js&"
import style0 from "./modelObmen.vue?vue&type=style&index=0&id=2aae6de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae6de5",
  null
  
)

export default component.exports